import script from "./Community.vue?vue&type=script&setup=true&lang=js"
export * from "./Community.vue?vue&type=script&setup=true&lang=js"

import "./Community.vue?vue&type=style&index=0&id=7d919980&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d919980"]])

export default __exports__